import React, { FunctionComponent } from 'react'
import { Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export type IncidentsIconProps = {
  size?: number
  fillColor?: string
}

/**
 * Incidents icon for Lyra Connect (alert/notification bell with rays)
 * Based on SideNavIcons/Incidents/Active from Lyra Connect Figma design system
 */
export const IncidentsIcon: FunctionComponent<IncidentsIconProps> = ({ size = 24, fillColor }) => {
  const { colors } = useTheme()
  const fill = fillColor || colors.iconDefault
  return (
    <Svg width={size} height={size} viewBox='0 0 32 32' fill='none'>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18 10.9331C20.4 10.9331 22.5336 12.6669 22.9336 15.0669L24.7998 25.6001H26.667C27.2001 25.6003 27.7333 26.0001 27.7334 26.6665C27.7334 27.333 27.2002 27.7327 26.667 27.7329H5.33301C4.66651 27.7328 4.2666 27.3331 4.2666 26.6665C4.26672 26.0001 4.79983 25.6002 5.33301 25.6001H7.2002L9.06641 15.0669C9.46641 12.6669 11.6 10.9331 14 10.9331H18ZM14 14.6665C13.3335 14.6665 12.8005 15.0666 12.667 15.7329L11.2002 24.0005H16V14.6665H14Z'
        fill={fill}
      />
      <Path
        d='M5.33301 17.6001C5.99958 17.6001 6.40028 18.1332 6.40039 18.6665C6.40039 19.1998 5.86634 19.7329 5.33301 19.7329H2.66699C2.00033 19.7329 1.59961 19.3332 1.59961 18.6665C1.59973 18 2.13372 17.6001 2.66699 17.6001H5.33301Z'
        fill={fill}
      />
      <Path
        d='M29.333 17.6001C29.8663 17.6001 30.4003 18 30.4004 18.6665C30.4004 19.3332 29.8663 19.7329 29.333 19.7329H26.667C26.0003 19.7329 25.5996 19.3332 25.5996 18.6665C25.5997 18 26.1337 17.6001 26.667 17.6001H29.333Z'
        fill={fill}
      />
      <Path
        d='M5.33301 8.1333C5.73297 7.73334 6.39979 7.73342 6.7998 8.1333L8.66699 10.0005C9.06647 10.4004 9.06647 11.0664 8.66699 11.4663C8.53367 11.5996 8.26665 11.7329 8 11.7329C7.73333 11.7329 7.46634 11.6002 7.33301 11.3335L5.33301 9.6001C4.93316 9.20012 4.93315 8.53327 5.33301 8.1333Z'
        fill={fill}
      />
      <Path
        d='M25.0664 8.1333C25.4664 7.73333 26.1332 7.73339 26.5332 8.1333C26.9332 8.5333 26.9332 9.2001 26.5332 9.6001L24.667 11.4663C24.5337 11.5996 24.2667 11.7329 24 11.7329C23.7333 11.7329 23.4669 11.5996 23.2002 11.4663C22.8003 11.0663 22.8003 10.4005 23.2002 10.0005L25.0664 8.1333Z'
        fill={fill}
      />
      <Path
        d='M16 4.26709C16.6666 4.26711 17.0664 4.80017 17.0664 5.3335V8.00049C17.0662 8.66688 16.5332 9.06687 16 9.06689C15.4668 9.06689 14.9339 8.53368 14.9336 8.00049V5.3335C14.9336 4.80016 15.3333 4.26709 16 4.26709Z'
        fill={fill}
      />
    </Svg>
  )
}
